export default __webpack_public_path__ + "static/review-bg-left-16496de8e830715c4e8c8e06eea9f9b0.svg";